import { render, staticRenderFns } from "./StreetDetail.vue?vue&type=template&id=05a2c7dc&scoped=true"
import script from "./StreetDetail.vue?vue&type=script&lang=js"
export * from "./StreetDetail.vue?vue&type=script&lang=js"
import style0 from "./StreetDetail.vue?vue&type=style&index=0&id=05a2c7dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05a2c7dc",
  null
  
)

export default component.exports